import * as actionType from "../ActionTypes";
import * as mutationType from "../MutationType";
import api from "../../config/api";
const state = {
};
const getters = {
};

const actions = {
    [actionType.ADD_HOT_DEALS]: async function ({commit}, params){
        return new Promise((resolve,reject) => {
            api.post(`/admin/packages/hotdeals`,params).then(result => {
                resolve(result);
            })
            .catch(error => reject(error));
        });
    },
    [actionType.UPDATE_HOT_DEALS]: async function ({commit}, params){
        return new Promise((resolve,reject) => {
            api.put(`/admin/packages/hotdeals/${params.id}`,params.body).then(result => {
                resolve(result);
            })
            .catch(error => reject(error));
        });
    },
    [actionType.DELTE_HOT_DEALS]: async function ({commit}, params){
        return new Promise((resolve,reject) => {
            api.delete(`/admin/packages/hotdeals/${params.id}`).then(result => {
                resolve(result);
            })
            .catch(error => reject(error));
        });
    },
    [actionType.GET_LIST_OF_HOT_DEALS]: async function ({commit}, params){
        return new Promise((resolve,reject) => {
            api.get(`/admin/packages/hotdeals`,{params}).then(result => {
                resolve(result);
            })
            .catch(error => reject(error));
        });
    },
    [actionType.TOGGLE_HOTDEALS_ACTIVE]: async function ({commit}, params){
        return new Promise((resolve,reject) => {
            api.put(`/admin/packages/hotdeals/${params.id}/active`,{}).then(result => {
                resolve(result);
            })
            .catch(error => reject(error));
        });
    },
};

const mutations = {
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}